import { BookOpen, Circle, Globe, GraduationCap, Key, List, School, Shield, UserRound, Users } from "lucide-react";

const ICONS = {
  shield: Shield,
  key: Key,
  guide: BookOpen,
  learner: GraduationCap,
  curriculum: BookOpen,
  counselor: UserRound,
  parent: Users,
  globe: Globe,
  school: School,
  list: List,
  default: Circle,
} as const;

export type BadgeIconName = keyof typeof ICONS;

export default function BadgeIcon({ name }: { name?: string }) {
  const key = (name && name in ICONS ? name : "default") as BadgeIconName;
  const Icon = ICONS[key];
  return <Icon className="al-badge-icon" aria-hidden="true" strokeWidth={2} />;
}
